import { NavLink } from "react-router-dom";

function Footer() {
  return (
    <footer className="site-footer footer-dark">
      <div className="sx-f-nl-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-12">
              <h2 className="sx-f-title">Professional security support for people, assets and operations.</h2>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="sx-nl-form">
                <form>
                  <div className="sx-nl-form-inner">
                    <input type="text" className="sx-nl-form-input" placeholder="info@neuronconsultancy.co.ke" />
                    <button className="sx-nl-form-btn"><i className="flaticon-back-left" /></button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-top">
        <div className="container">
          <div className="row">
            <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
              <div className="widget widget_about">
                <div className="logo-footer clearfix p-b15">
                  <NavLink to="/" className="logo-brand logo-footer-brand">
                    <img src="/neurologo.png" alt="Neuron Consultancy Kenya logo" className="logo-image" />
                  </NavLink>
                </div>
                <p>Kenyan-based risk and threat mitigation company providing close protection, surveillance and specialist security solutions.</p>
                <div className="widget_about-call-section">
                  <div className="sx-f-call-icon"><i className="flaticon-telephone" /></div>
                  <div className="sx-f-call-section">
                    <span>24/7 Contact</span>
                    <a href="tel:+254725642469">+254 725 642 469</a>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
              <div className="widget widget_services">
                <h4 className="sx-f-title">Company</h4>
                <ul>
                  <li><NavLink to="/about-us">About</NavLink></li>
                  <li><NavLink to="/mission">Mission</NavLink></li>
                  <li><NavLink to="/services">Services</NavLink></li>
                  <li><NavLink to="/operations">Operations</NavLink></li>
                  <li><NavLink to="/contact-us">Contact</NavLink></li>
                </ul>
              </div>
            </div>

            <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
              <div className="widget widget_services">
                <h4 className="sx-f-title">Capabilities</h4>
                <ul>
                  <li><NavLink to="/services">VIP Protection</NavLink></li>
                  <li><NavLink to="/services">Surveillance</NavLink></li>
                  <li><NavLink to="/services">Travel Security</NavLink></li>
                  <li><NavLink to="/services">HEAT Training</NavLink></li>
                  <li><NavLink to="/services">Stakeholder Security</NavLink></li>
                </ul>
              </div>
            </div>

            <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
              <div className="widget widget_info">
                <h4 className="sx-f-title">Contact</h4>
                <ul>
                  <li><div className="widget-info-icon"><i className="flaticon-phone" /></div><div className="widget-info-detail"><a href="tel:+254725642469">+254 725 642 469</a></div></li>
                  <li><div className="widget-info-icon"><i className="flaticon-email" /></div><div className="widget-info-detail"><a href="mailto:info@neuronconsultancy.co.ke">info@neuronconsultancy.co.ke</a><a href="mailto:protection@neuronconsultancy.co.ke">protection@neuronconsultancy.co.ke</a></div></li>
                  <li><div className="widget-info-icon"><i className="flaticon-maps-and-flags" /></div><div className="widget-info-detail"><p>Ack garden, 1st Ngong Avenue, 2 Foor, wing A, Nairobi - Kenya</p></div></li>
                </ul>
              </div>
            </div>

          
          </div>
        </div>
      </div>

      <div className="sx-f-bottom-section">
        <div className="sx-f-social">
          <ul>
            <li><a href="https://www.facebook.com/"><i className="flaticon-facebook" /></a></li>
            <li><a href="https://twitter.com/"><i className="flaticon-twitter" /></a></li>
            <li><a href="https://www.linkedin.com/"><i className="flaticon-linkedin" /></a></li>
            <li><a href="https://www.instagram.com/"><i className="flaticon-instagram" /></a></li>
          </ul>
        </div>
        <div className="sx-f-copy">© 2026 by <NavLink to="/">Neuron Consultancy Kenya Ltd.</NavLink> All rights reserved.</div>
      </div>
    </footer>
  );
}

export default Footer;
